export default __webpack_public_path__ + "img/zZfXJsgS.790b476e.svg";